"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveCustomFieldTypeLocation = exports.resolveCustomFieldTypePictureOrFile = exports.resolveCustomFieldTypeDatePicker = exports.getScolParamsForMatrix = exports.resolveCustomFieldTypeMXOL = exports.resolveCustomFieldTypeSCOL = exports.resolveCustomFieldTypeMultipleChoice = exports.resolveCustomFieldTypeSingleChoice = void 0;
const format_1 = require("date-fns/format");
const lodash_1 = __importStar(require("lodash"));
const types_1 = require("../../types");
const resolveItemScope_1 = require("../resolveMetaExpression/resolveItemScope");
const flattenGenericMatrix_1 = require("./flattenGenericMatrix");
const resolveScope_1 = require("./resolveScope");
const sqlDynamicSchemaTools_1 = require("./sqlDynamicSchemaTools");
const utils_1 = require("./utils");
// Resolves Custom Field of Type Single Choice
const resolveCustomFieldTypeSingleChoice = (metaExpression, options) => {
    const { schema, object, get_options_label } = options;
    let answer = (0, utils_1.getSafeValue)(object, metaExpression.custom_field1);
    answer = (0, utils_1.getSafeOptionKey)(answer);
    // __active_activity_report/__custom_field:scolquestion/__option_tag:label1
    if (metaExpression.option_tag) {
        answer = metaExpression.option_tag === answer ? true : false;
    }
    if (get_options_label && !metaExpression.option_tag) {
        answer = (0, utils_1.getOptionsLabel)({
            key: answer,
            metaExpression,
            schema,
        });
    }
    if (answer == undefined)
        return (0, utils_1.getMeResultNoResult)();
    return (0, utils_1.getMeResultCustomFieldResult)(answer);
};
exports.resolveCustomFieldTypeSingleChoice = resolveCustomFieldTypeSingleChoice;
// Resolves Custom Field of Type Multiple Choice
const resolveCustomFieldTypeMultipleChoice = (metaExpression, options) => {
    const { object } = options;
    //ME of the form: ${__active_activity_report/__custom_field:category}
    let answer = (0, utils_1.getSafeValue)(object, metaExpression.custom_field1);
    if (answer == undefined)
        return (0, utils_1.getMeResultNoResult)();
    answer = (0, utils_1.getSafeOptionKeyArray)(answer);
    //ME of the form: ${__active_activity_report/__custom_field:category/__option_tag:cat2}
    if (metaExpression.option_tag) {
        answer = lodash_1.default.includes(answer, metaExpression.option_tag);
    }
    return (0, utils_1.getMeResultCustomFieldResult)(answer);
};
exports.resolveCustomFieldTypeMultipleChoice = resolveCustomFieldTypeMultipleChoice;
// Resolves Custom Field of Type Single Choice On List
const resolveCustomFieldTypeSCOL = (metaExpression, options) => {
    var _a, _b;
    const { scolParams, get_options_label, object } = options;
    const _scolParams = Array.isArray(scolParams)
        ? (_a = scolParams.find((i) => { var _a; return ((_a = i.scolItem) === null || _a === void 0 ? void 0 : _a._id) == object[metaExpression.custom_field1]; })) !== null && _a !== void 0 ? _a : undefined
        : scolParams;
    if (!_scolParams || !_scolParams.scolList || !_scolParams.scolItem)
        return (0, utils_1.getMeResultNoResult)();
    if (!metaExpression.custom_field1 ||
        !_scolParams.scolItem._id ||
        !(object[metaExpression.custom_field1] ==
            _scolParams.scolItem._id))
        return (0, utils_1.getMeResultNoResult)();
    // call resolveItemScope
    const res = (0, resolveItemScope_1.resolveItemScope)(Object.assign(Object.assign({}, metaExpression), { scope: types_1.META_EXPRESSION_SCOPE.ITEM, custom_field1: (_b = metaExpression.custom_field2) !== null && _b !== void 0 ? _b : "_id", custom_field2: metaExpression.custom_field3, option_tag: metaExpression.option_tag }), {
        item: _scolParams.scolItem,
        list: _scolParams.scolList,
        get_options_label: get_options_label,
    });
    if (res.type == types_1.ME_RESULT_TYPE.NO_RESULT)
        return (0, utils_1.getMeResultNoResult)();
    return (0, utils_1.getMeResultCustomFieldResult)(res.result);
};
exports.resolveCustomFieldTypeSCOL = resolveCustomFieldTypeSCOL;
// Resolves Custom Field of Type Matrix On List
const resolveCustomFieldTypeMXOL = (metaExpression, options) => {
    var _a;
    const { mxolParams, object } = options;
    let matrixData = (0, flattenGenericMatrix_1.flattenGenericMatrix)((0, utils_1.getSafeValue)(object, metaExpression.custom_field1));
    const _mxolParams = Array.isArray(mxolParams)
        ? (_a = mxolParams.find((mp) => (mp === null || mp === void 0 ? void 0 : mp.tag) == metaExpression.custom_field1)) !== null && _a !== void 0 ? _a : undefined
        : mxolParams;
    if (!matrixData || !_mxolParams || !_mxolParams.matrix)
        return (0, utils_1.getMeResultNoResult)();
    const refIds = (_mxolParams === null || _mxolParams === void 0 ? void 0 : _mxolParams.mxolItems)
        ? _mxolParams.mxolItems.map((i) => i._id)
        : undefined;
    const resultList = Object.entries(matrixData).reduce((acc, [key, value]) => {
        // for long lists in front end, mxolItems is not set, so can skip this check
        if (refIds && !lodash_1.default.includes(refIds, key))
            return acc;
        const schema = (0, sqlDynamicSchemaTools_1.extractActivityOrListSchema)({
            questionnaire: { questions: _mxolParams.matrix.typed_questions },
        }, true);
        let scolParamsForKey;
        if (_mxolParams.scolParams)
            scolParamsForKey = _mxolParams.scolParams[key]; //getScolParamsForMatrix(schema, metaExpression, key, options.mxolParams?.scolParams);
        const res = (0, resolveScope_1.resolveScopeWithSchema)(Object.assign(Object.assign({}, metaExpression), { scope: types_1.META_EXPRESSION_SCOPE.ITEM, custom_field1: metaExpression.custom_field2, custom_field2: metaExpression.custom_field3, custom_field3: undefined, option_tag: metaExpression.option_tag }), {
            object: value,
            schema,
            get_options_label: options.get_options_label,
            scolParams: scolParamsForKey,
        });
        acc[key] = res.result;
        return acc;
    }, {});
    return (0, utils_1.getMeResultMatrixIterationResult)(resultList);
};
exports.resolveCustomFieldTypeMXOL = resolveCustomFieldTypeMXOL;
const getScolParamsForMatrix = (schema, metaExpression, itemId, scolParams) => {
    if (!scolParams)
        return undefined;
    const customField = schema.find((q) => q.tag == metaExpression.custom_field2);
    const fieldType = customField === null || customField === void 0 ? void 0 : customField.type;
    if (fieldType == types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE_ON_LIST) {
        return scolParams[itemId];
    }
    return undefined;
};
exports.getScolParamsForMatrix = getScolParamsForMatrix;
// Resolves Custom Field of Type Date Picker
const resolveCustomFieldTypeDatePicker = (metaExpression, options) => {
    //assume all returns format "1977-09-13T00:00:00.000Z".
    const val = (0, utils_1.getSafeValue)(options.object, metaExpression.custom_field1);
    if (val == undefined)
        return (0, utils_1.getMeResultNoResult)();
    const date = (0, format_1.format)(new Date(val), "MMM dd, yyyy");
    return (0, utils_1.getMeResultCustomFieldResult)(date);
    //the following special case left out
    //         TODO: special case for item... Really not a fan of that, let's see if we can change it one day...
    //         return format(
    //             new Date(
    //             item![(metaExpression.custom_field1 || metaExpression.field)!]
    //             ),
    //             "MMM dd,yyyy"
    //         );
};
exports.resolveCustomFieldTypeDatePicker = resolveCustomFieldTypeDatePicker;
const resolveCustomFieldTypePictureOrFile = (metaExpression, options) => {
    const picture = (0, utils_1.getSafeValue)(options.object, metaExpression.custom_field1);
    if (picture == undefined)
        return (0, utils_1.getMeResultNoResult)();
    function encodeSpacesInUrl(url) {
        if (typeof url !== "string") {
            return url;
        }
        if (url.includes(" ")) {
            // Encode spaces to %20
            return url.replace(/ /g, "%20");
        }
        return url;
    }
    return (0, utils_1.getMeResultCustomFieldResult)(picture.hasOwnProperty("url")
        ? encodeSpacesInUrl(picture.url)
        : encodeSpacesInUrl(picture));
};
exports.resolveCustomFieldTypePictureOrFile = resolveCustomFieldTypePictureOrFile;
const resolveCustomFieldTypeLocation = (metaExpression, options) => {
    const location = (0, utils_1.getSafeValue)(options.object, metaExpression.custom_field1);
    console.log(location);
    if (location == undefined)
        return (0, utils_1.getMeResultNoResult)();
    else if (location.lat == undefined || location.lng == undefined)
        return (0, utils_1.getMeResultNoResult)();
    else if ((0, lodash_1.isEmpty)(location))
        return (0, utils_1.getMeResultNoResult)();
    const formatedLocation = `${location.lat};${location.lng}`;
    return (0, utils_1.getMeResultCustomFieldResult)(formatedLocation);
};
exports.resolveCustomFieldTypeLocation = resolveCustomFieldTypeLocation;
